<script>
import DidoApidoc from "./components/Apidoc.vue";

export default {
  name: "DidoApidocCe",
  components: {
    DidoApidoc,
  },
  props: {
    didoUrl: { type: String, required: true },
  },
  emits: ["bad-configuration"],
  template: `
    <DidoApidoc
      :api-url="didoUrl"
      @bad-configuration="$emit('bad-configuration')"
    />`,
};
</script>
